import type { Language } from '@inflearn/i18n-tools';
import type { GetServerSidePropsContext } from 'next';
import { useTranslation } from 'next-i18next';
import type { ReactElement } from 'react';
import PartnersPolicyLayout from '../../../components/layout/PolicyLayout/partners';
import { PolicyContent } from '../../../components/pages/policy/PolicyContent';
import { getCdnTranslationProps } from '../../../utils/server/i18n/getCdnTranslationProps';

export const getServerSideProps = async (context: GetServerSidePropsContext) => {
  const locale = context.locale as Language;
  const isWebview = context.query.type === 'app';

  return {
    props: {
      isWebview: isWebview,
      ...(await getCdnTranslationProps(locale, ['common'])),
    },
  };
};

export default function PartnersTermsPage({
  isWebview,
}: {
  isWebview: boolean;
}) {
  const { t } = useTranslation();

  return (
    <PolicyContent
      title={t('파트너스 이용약관')}
      type="MARKETING_PARTNERS_TERMS"
      period="CURRENT"
      isWebview={isWebview}
      // @NOTE: 이전 이용 약관 생성 시, 해당 주석 해제
      // prevPolicy={{
      //   href: '/policy/previous-partners-terms',
      //   buttonText: '이전 이용 약관 보기',
      // }}
    />
  );
}

PartnersTermsPage.getLayout = (page: ReactElement) => (
  <PartnersPolicyLayout
    meta={{
      title: '파트너스 이용약관',
      description: '메타.파트너스이용약관.설명',
    }}
  >
    {page}
  </PartnersPolicyLayout>
);
